// The text of one saved deck in a "choose a deck" list (Lane 1372, Ryan: four decks for
// the same supplier looked the same). Each deck shows its title, the supplier when the
// title does not already name it, and the day it was built ("built October 4, 2026").
// Used by the Meeting Prep deck chooser and the deck page's "Load a saved deck" list.

// `built_at` (deck_compose.list_compositions) carries its time zone, so the day is the
// buyer's own day. A value that does not read as a date gives no date, never a guess.
export function formatBuiltDate(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}

export default function savedDeckLabel(deck, { author = false } = {}) {
  const title = String(deck.title || '').trim();
  const supplier = String(deck.supplier_name || '').trim();
  const parts = [title || supplier || 'Untitled deck'];
  if (title && supplier && !title.toLowerCase().includes(supplier.toLowerCase())) parts.push(supplier);
  const built = formatBuiltDate(deck.built_at);
  if (built) parts.push(`built ${built}`);
  if (author) parts.push(deck.author_name || 'author unknown');
  return parts.join(' · ');
}
